/** @jsx jsx */
import { jsx, Box } from "theme-ui"

export default ({ size }) => <Box sx={{ my: size }} />
